import { TStyles } from "utils/Styles";

const styles: TStyles = {
  expandMoreButton: {
    p: 1,
  },

  listItem: {
    flexWrap: "wrap",

    "&.MuiAutocomplete-option": {
      p: 0,
    },
  },
};

export default styles;
